import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { IMAGE_BASE_URL } from "../../../constants/configuration";

export default function Activities({ details, activityName, packageID }) {
  const [showAll, setShowAll] = useState(false);
  const [activities, setActivities] = useState([]);
  const [visibleCount, setVisibleCount] = useState(4);

  const data = details?.activity_attraction?.itinerary;
  const visibleActivities = activities.slice(0, visibleCount);

  useEffect(() => {
    if (data) {
      const allActivities = details?.activity_attraction?.itinerary?.flatMap(item => item.activity) || [];
      setActivities(allActivities);
    }
  }, [data]);

  return (
    <div className="attraction">
      <div className="container">
        <div className="header">
          <h2 className="title">Activities</h2>
          {/* {activities.length > 4 && (
            <div className="view" onClick={() => setShowAll(!showAll)}>
              {showAll ? "Show Less" : "View All"}
              <img src="/assets/img/icons/btn-arrow.svg" alt="" />
            </div>
          )} */}
        </div>
        <div className="row">
          {visibleActivities?.map((ele, i) => {
            return (
              <div className="col-md-3" key={i}>
                <Link to={`/activity-details/${ele?.handle_key}/${packageID}`}>
                  <div className="atraction">
                    <div className="image">
                      <img
                        src={`${IMAGE_BASE_URL}activity/${ele?.image}`}
                        alt={ele.image_alt}
                        className="w-100"
                      />
                    </div>
                    <div className="contents">
                      <h3>{ele?.title}</h3>
                      <p>
                        <img
                          src="/assets/img/icons/clock.svg"
                          height={17}
                          alt=""
                        />
                        Duration {ele?.duration} hours
                      </p>
                    </div>
                  </div>
                </Link>
              </div>
            );
          })}
        </div>
        <div className="view__more">
          {activities.length > visibleCount && (
            <div className="view" onClick={() => setVisibleCount(prev => prev + 4)}>
              View More
              <img src="/assets/img/icons/btn-arrow.svg" alt="" />
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
